export default __webpack_public_path__ + "static/media/svg-3.1303bf65.svg";